import Select from 'react-select';
import React from 'react';
import Clearfix from 'components/elements/clearfix';
import styled from 'styled-components';

const options = [
  { key: 0, value: undefined, label: '--Select--' },
  { key: 1, value: 'false', label: 'Không có mã QLCTNH' },
  { key: 2, value: 'true', label: 'Có mã QLCTNH' },
];

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const SelectQLCTNH = ({ getFieldProps }) => {
  return (
    <Container>
      <span>QLCTNH</span>
      <Clearfix width={8} />
      <div style={{ flex: 1 }}>
        <Select
          isClearable
          style={{ flex: 1 }}
          placeholder='--Select--'
          options={options}
          classNamePrefix='react-select-custom'
          {...getFieldProps}
        />
      </div>
    </Container>
  );
};

export default SelectQLCTNH;



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportList/SelectQLCTNH.js